import {IAddress} from "../interfaces/address";
import {Address, IGeoJSONPayload} from "./address";

/**
 * serializable user address
 */
export class UserAddress extends Address implements IAddress {
  public firstname: string;
  public lastname: string;
  public street: string;
  public streetnumber: string;
  public postalcode: string | number;
  public location?: string;
  public floor?: string;
  public identifier: number;
  public political: string;
  public sublocality: string;


  static fromPrediction(http, prediction) {
    let name = prediction.description;
    let params = [
      "address=", encodeURIComponent(name), "&", "key=", "AIzaSyD2twUnJccvdw_4YGGG38O9g2kxbN_7XOk"].join("");
    return new Promise((resolve, reject) => {
      http.get(
        `https://maps.googleapis.com/maps/api/geocode/json?${params}`
      ).map(res => res.json()).subscribe(
        result => {
          resolve(UserAddress.fromGeolocation(result.results[0]))
        },
        err => reject(err)
      );
    });
  }

  static fromGeolocation(payload: IGeoJSONPayload) {
    let street = "";
    let streetnumber = "";
    let postalcode = "";
    let location = "";
    let sublocation = "";

    const address = super.fromGeolocation(payload);
    // TODO: Somehow useraddress seems redundant :D
    return new UserAddress({
      ...address,
      ...payload.geometry.location,
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/classes/user_address.ts